module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-box-image-7-944f2466225904f69d691ef593d7caab.jpg";